export class ICESCell {
    public ICESName: string;
    public Coordinates: any[];
}